import CatalogEntryEvaluationApproachPanel from "./CatalogEntryEvaluationApproachPanel";
import CatalogEntryMetadataPanel from "./CatalogEntryMetadataPanel";
import CatalogEntryOptionalDetailsPanel from "./CatalogEntryOptionalDetailsPanel";
import CatalogEntryOverviewPanel from "./CatalogEntryOverviewPanel";
import CatalogEntrySourcesAttributionPanel from "./CatalogEntrySourcesAttributionPanel";
import CatalogEntryUserAccessPanel from "./CatalogEntryUserAccessPanel";
import CatalogEntryVoiceSamplesPanel from "./CatalogEntryVoiceSamplesPanel";
import {
  hasInstrumentMetadata,
  hasMethodMetadata,
  isSimpleAccessEntry
} from "./detailUtils";
import {
  buildCatalogEntryMetadataPanelProps,
  getCatalogEntryDetailProfile
} from "./catalogDetailProfiles";

export default function CatalogEntryInformationPanels({
  entry,
  selectedLaunchConfiguration = null,
  className = "catalog-detail__info-grid"
}) {
  if (!entry) {
    return null;
  }

  const detailProfile = getCatalogEntryDetailProfile(entry);
  const metadataPanelProps =
    buildCatalogEntryMetadataPanelProps(entry, detailProfile);
  const hasSimpleAccessPresentation =
    isSimpleAccessEntry(entry);
  const shouldRenderInstrumentPanel =
    detailProfile.panels.instrument &&
    hasInstrumentMetadata(entry?.metadata?.instrument);
  const shouldRenderMethodPanel =
    detailProfile.panels.instrument &&
    !shouldRenderInstrumentPanel &&
    hasMethodMetadata(entry?.metadata?.method);

  return (
    <section className={className}>
      {detailProfile.panels.purpose && (
        <CatalogEntryOverviewPanel entry={entry} />
      )}

      {detailProfile.panels.access && (
        hasSimpleAccessPresentation ? null : (
          <CatalogEntryUserAccessPanel entry={entry} />
        )
      )}

      {detailProfile.panels.details && (
        <CatalogEntryOptionalDetailsPanel entry={entry} />
      )}

      {metadataPanelProps && (
        <CatalogEntryMetadataPanel
          title={metadataPanelProps.title}
          rows={metadataPanelProps.rows}
        />
      )}

      {(shouldRenderInstrumentPanel || shouldRenderMethodPanel) && (
        <CatalogEntryEvaluationApproachPanel entry={entry} />
      )}

      <CatalogEntryVoiceSamplesPanel
        entry={entry}
        selectedLaunchConfiguration={selectedLaunchConfiguration}
      />

      {detailProfile.panels.rights && (
        <CatalogEntrySourcesAttributionPanel entry={entry} />
      )}
    </section>
  );
}
